import { FinancialSituationNetWorth } from '../../../../types';
export var list = [
    FinancialSituationNetWorth.FROM_0_TO_200K,
    FinancialSituationNetWorth.FROM_200K_TO_500K,
    FinancialSituationNetWorth.FROM_500K_TO_800K,
    FinancialSituationNetWorth.FROM_800K_TO_1M,
    FinancialSituationNetWorth.ABOVE_1M,
];
